import React from "react"
import { MapPin, Rocket, ShieldCheck, Globe2 } from "lucide-react"
import { useTranslation } from "react-i18next"
import { useScrollAnimation } from "../hooks/useScrollAnimation"

export default function AboutUs() {
    const { t } = useTranslation()
    const ref = useScrollAnimation()

    return (
        <section id="about-us" ref={ref} className="scroll-animate py-24 bg-white relative overflow-hidden">
            {/* Background Accents */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl">
                <div className="absolute top-10 left-10 w-64 h-64 bg-emerald-500/5 rounded-full blur-3xl"></div>
                <div className="absolute bottom-10 right-10 w-64 h-64 bg-blue-500/5 rounded-full blur-3xl"></div>
            </div>

            <div className="container mx-auto px-4 md:px-6 relative z-10">
                <div className="max-w-4xl mx-auto text-center mb-16">
                    <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-5xl mb-6">
                        {t('about.title')}
                    </h2>
                    <p className="text-xl font-medium text-emerald-600 mb-8">
                        {t('about.subtitle')}
                    </p>
                </div>

                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    <div className="space-y-8">
                        <div className="p-8 bg-slate-50 rounded-[2rem] border border-slate-100 shadow-sm hover:shadow-md transition-shadow">
                            <p className="text-lg text-slate-700 leading-relaxed italic">
                                "{t('about.content')}"
                            </p>
                        </div>

                        <div className="flex flex-wrap gap-4">
                            <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-100 text-emerald-700 text-sm font-bold">
                                <MapPin className="w-4 h-4" />
                                USA & UK
                            </div>
                            <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-blue-100 text-blue-700 text-sm font-bold">
                                <Rocket className="w-4 h-4" />
                                Zig Investment Ecosystem
                            </div>
                        </div>
                    </div>

                    <div className="grid sm:grid-cols-2 gap-6">
                        <div className="p-6 bg-white rounded-3xl border border-slate-100 shadow-sm hover:border-emerald-500/30 transition-colors group">
                            <div className="w-12 h-12 bg-emerald-50 rounded-2xl flex items-center justify-center mb-4 group-hover:bg-emerald-500 transition-colors">
                                <Globe2 className="w-6 h-6 text-emerald-600 group-hover:text-white" />
                            </div>
                            <h3 className="text-xl font-bold text-slate-900 mb-2">{t('about.visionTitle')}</h3>
                            <p className="text-slate-600 text-sm">{t('about.visionContent')}</p>
                        </div>
                        <div className="p-6 bg-white rounded-3xl border border-slate-100 shadow-sm hover:border-emerald-500/30 transition-colors group">
                            <div className="w-12 h-12 bg-emerald-50 rounded-2xl flex items-center justify-center mb-4 group-hover:bg-emerald-500 transition-colors">
                                <ShieldCheck className="w-6 h-6 text-emerald-600 group-hover:text-white" />
                            </div>
                            <h3 className="text-xl font-bold text-slate-900 mb-2">{t('about.techTitle')}</h3>
                            <p className="text-slate-600 text-sm">{t('about.techContent')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
